import React from 'react'
import { components, useTranslation } from 'cng-web-lib'
import { useParams, useLocation } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import CrewViewForm from './CrewViewPage'
import ResponseForm from '../acehighway/response/MedpidResponse'
import CrewMasterKeys from 'src/constants/locale/key/CrewMaster'

const { CngTabs } = components

function ViewPage({ showNotification, history }) {
  const { id } = useParams()
  const loc = useLocation()
  const { translate } = useTranslation([Namespace.CREW_MASTER])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let crew = translate(
      Namespace.CREW_MASTER,
      CrewMasterKeys.TITLE
    )
    let response = translate(
      Namespace.CREW_MASTER,
      CrewMasterKeys.RESPONSE_TITLE
    )
    return {
      crew,
      response
    }
  }


  return (
    <CngTabs
      headerColor='primary'
      tabs={[
        {
          tabName: translatedTextsObject.crew,
          tabContent: (
            <CrewViewForm
              showNotification={showNotification}
              id={id}
              history={history}
            />
          )
        },
        {
          tabName: translatedTextsObject.response,
          tabContent: (
            <ResponseForm
              showNotification={showNotification}
              id={id}
              headerId={loc.state.headerId}
              docType='ACE_MEDPID_CREW'
            />
          )
        }
      ]}
    />
  );
}

export default ViewPage
